<script setup lang="ts">
import type { HTMLAttributes } from "vue";

import { cn } from "../../lib/utils";

interface Props {
  class?: HTMLAttributes["class"];
}

const props = defineProps<Props>();
</script>

<template>
  <section :class="cn('ui-card', props.class)">
    <slot />
  </section>
</template>
